import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useMemo, useState } from 'react'
import { Post } from '../../../../mocks/posts'
import ContentState from '../../../../stores/ContentState'
import PostModel from '../../../../stores/PostModel'
import Pagination from '../../../common/Pagination'
import Tabs from '../../../common/Tabs'
import NewsPost from '../NewsPost'
import NewsTabs from '../NewsTabs'
import './index.scss'
const NewsContent = observer(() => {
  const [currentPage, setCurrentPage] = useState(1)
  const [lastPage, setLastPage] = useState(0)
  const [width, setWidth] = useState(window.innerWidth)
  const [showMore, setMore] = useState(0)
  const [countPerPage, setCount] = useState(5)
  const [count, setPageCount] = useState(Array())
  const [currentItems, setCurrentItems] = useState<Array<Post> | null>([])
  const [currentTableData, setData] = useState<Array<Post> | null | undefined>(
    Array(),
  )

  useEffect(() => {
    let prev = 0
    if (currentPage - 1) {
      for (let i = currentPage - 2; i >= 0; i--) {
        prev += count[i]
      }
    }
    const firstPageIndex = prev
    const lastPageIndex = firstPageIndex + count[currentPage - 1]

    setData(currentItems?.slice(firstPageIndex, lastPageIndex))
  }, [currentPage, currentItems, count])

  const [topic, setTopic] = useState('')

  useEffect(() => {
    if (!currentItems) return
  }, [PostModel.posts])

  useEffect(() => {
    if (showMore) {
      let arr = count
      arr[currentPage - 1] += count[currentPage] ? count[currentPage] : 0

      arr.splice(currentPage, 1)
      setPageCount([...arr])
    }
  }, [showMore])

  useEffect(() => {
    setMore(0)
  }, [currentPage, topic])

  useEffect(() => {
    if (!ContentState.news) return
    setTopic((ContentState.news as any).topics[0])
  }, [ContentState.news])

  useEffect(() => {
    setCurrentPage(1)
  }, [topic])

  useEffect(() => {
    if (!ContentState.news) return
    if (topic == (ContentState.news as any)?.topics[0]) {
      setCurrentItems(PostModel.posts)
      if (!PostModel.posts) return
      const cnt = Math.ceil(PostModel.posts!.length / countPerPage)
      const arr: Array<number> = []
      let maxLength = PostModel.posts!.length
      for (let i = cnt - 1; i >= 0; i--) {
        arr.push(maxLength - countPerPage * i)
        maxLength -= maxLength - countPerPage * i
      }
      setPageCount(arr.reverse())
    } else {
      if (!PostModel.posts) return
      setCurrentItems(
        PostModel.posts?.filter((p) => p.topic.trim() == topic.trim()) || null,
      )

      const cnt = Math.ceil(
        PostModel.posts?.filter((p) => p.topic.trim() == topic.trim()).length /
          countPerPage,
      )
      const arr: Array<number> = []
      let maxLength = PostModel.posts?.filter(
        (p) => p.topic.trim() == topic.trim(),
      ).length
      for (let i = cnt - 1; i >= 0; i--) {
        arr.push(maxLength - countPerPage * i)
        maxLength -= maxLength - countPerPage * i
      }
      setPageCount(arr.reverse())
    }
  }, [topic, PostModel.posts, ContentState.news])

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth)
    })
  }, [])

  if (!PostModel.posts) return <></>
  if (!ContentState.news) return <></>
  const content: any = ContentState.news

  return (
    <section className="news-page">
      <div className="news-page__top">
        {width > 760 && (
          <NewsTabs
            dt={content.topics}
            topic={topic}
            setTopic={(value) => setTopic(value)}
          />
        )}
        {width <= 760 && (
          <>
            <NewsTabs
              dt={content.topics.slice(0, 3)}
              topic={topic}
              setTopic={(value) => setTopic(value)}
            />
            <NewsTabs
              dt={content.topics.slice(3, content.topics.length)}
              topic={topic}
              setTopic={(value) => setTopic(value)}
            />
          </>
        )}
      </div>
      <div className="news-page__list">
        {currentTableData?.map((po, i) => (
          <NewsPost dt={po} key={i} content={content} />
        ))}
      </div>
      {currentItems && currentItems.length ? (
        <div className="news-page__bottom">
          <Pagination
            getLastPage={(value) => setLastPage(value)}
            currentPage={currentPage}
            setCurrentPage={(value) => {
              setCurrentPage(value)
              window.scrollTo(0, 0)
            }}
            data={currentItems as any}
            itemsPerPage={count.length}
          />
          {currentPage != lastPage && showMore != countPerPage && (
            <div
              className="button black"
              onClick={() => {
                setMore(countPerPage)
              }}
            >
              {content.showButton}
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </section>
  )
})

export default NewsContent
